/**
 * Interpole les paramètres d'un message : {name} et {{name}} sont supportés.
 * Les tokens sans valeur fournie sont laissés tels quels.
 */
export function interpolate(message, values) {
    if (!values) {
        return message;
    }
    return Object.entries(values).reduce((current, [key, value]) => current
        .replaceAll(`{{${key}}}`, String(value))
        .replaceAll(`{${key}}`, String(value)), message);
}
//# sourceMappingURL=interpolate.js.map